import { render, staticRenderFns } from "./pdfView.vue?vue&type=template&id=2fb2dca6&scoped=true&"
import script from "./pdfView.vue?vue&type=script&lang=js&"
export * from "./pdfView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2dca6",
  null
  
)

export default component.exports